import { ComponentIds } from '@inter-ikea-core/core';
import { PlannerEcsMultiSystem, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
const SHELF = '70584433';
/**
 * When removing cabinets, we must fill empty connectors with shelves
 * This system will check all sections in scene, and add shelves to empty connectors
 */
export class ReAddShelvesSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'ReAddShelvesSystem', [
            ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID,
            ComponentIds.IN_SCENE_COMPONENT_ID
        ]);
        this.placementService = coreApi.placementService;
    }
    onAdd(entity, oldComponent) {
        if (oldComponent.typeId === ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID) {
            const productType = entity.getComponent(ProductInfoComponent.id)
                ?.productType;
            // Check if cabinet was moved in scene
            if (productType === ProductType.LADMAKARE_CABINET) {
                this.fillEmptyConnectorsWithShelves();
            }
        }
    }
    onUpdate(entity, oldComponent) {
        if (oldComponent.typeId === ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID) {
            const productType = entity.getComponent(ProductInfoComponent.id)
                ?.productType;
            // Check if cabinet was moved in scene
            if (productType === ProductType.LADMAKARE_CABINET) {
                this.fillEmptyConnectorsWithShelves();
            }
        }
    }
    onRemove(entity, oldComponent) {
        if (oldComponent.typeId === ComponentIds.IN_SCENE_COMPONENT_ID) {
            const productType = entity.getComponent(ProductInfoComponent.id)
                ?.productType;
            // Check if cabinet was deleted from scene
            if (productType === ProductType.LADMAKARE_CABINET) {
                this.fillEmptyConnectorsWithShelves();
            }
        }
    }
    /**
     * Fill empty connectors with shelves
     */
    fillEmptyConnectorsWithShelves() {
        const framesInScene = this.coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
        framesInScene.forEach(frame => {
            const shelvesToAdd = 5; // Experienced issues when calculating this value, so just to be safe we go with 5 (max holes) for now
            Array.from({ length: shelvesToAdd }).forEach(() => {
                this.coreApi.products.addToTarget(SHELF, frame);
            });
        });
    }
}
//# sourceMappingURL=ReAddShelvesSystem.js.map